import { render, staticRenderFns } from "./DistributionQuickLink.vue?vue&type=template&id=4d4c8b9b&scoped=true&"
import script from "./DistributionQuickLink.vue?vue&type=script&lang=js&"
export * from "./DistributionQuickLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c8b9b",
  null
  
)

export default component.exports